export const round = (number: string, fractionDigits: number) => Number(parseFloat(number).toFixed(fractionDigits))